export default __webpack_public_path__ + "static/media/productManagerSVG.81129063.svg";